import { EquipmentTypeSearchRequest } from '@trukt/tms-api/EquipmentService';
import { createKey } from './createKey';

const keyHandler = createKey('equipment');

export const EquipmentServiceKeys = {
  key: keyHandler.key,
  searchTypes: keyHandler.createMethod<EquipmentTypeSearchRequest>(),
};
